import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {mobileNav} from "./modules/mobileNav";
import {headerSearch} from "./modules/headerSearch";
import {accordion} from "./modules/accordion";
import {video} from "./modules/video";
import {customSelect} from "./modules/customSelect";
import {infoCardSlider} from "./modules/infoCardSlider";
import {heroSlider} from "./modules/heroSlider";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {postsPagination} from "./modules/postsPagination";
import {formReset} from "./modules/formReset";
import {popups} from "./modules/popups";
import {advisorySolutionsSlider} from "./modules/advisorySolutionsSlider";
import {clientsSlider} from "./modules/clientsSlider";
import {postsSliderOnMobile} from "./modules/postsSliderOnMobile";
import {OurNumbersSliderOnMobile} from "./modules/OurNumbersSliderOnMobile";
import {featuresAccordion} from "./modules/featuresAccordion";
import {confirmPopup} from "./modules/confirmPopup";
import {knowledgeHubPagination} from "./modules/knowledgeHubPagination";
import {ingredientsSlider} from "./modules/ingredientsSlider";
import {content} from "./modules/content";


binder({
    bounds: {
        "html": [constants, fullHeightPage, customSelect],
        ".header": [mobileNav, headerSearch],
        ".accordion": accordion,
        ".video-holder": video,
        ".hero-slider": heroSlider,
        ".info-cards-slider": infoCardSlider,
        ".copied-link": copyLinkToBuffer,
        ".ajax-holder-posts": postsPagination,
        "button[type='reset']": formReset,
        ".popups": popups,
        ".advisory-solutions-slider": advisorySolutionsSlider,
        ".clients-slider": clientsSlider,
        ".posts.slider-on-mobile": postsSliderOnMobile,
        ".our-numbers.slider-on-mobile": OurNumbersSliderOnMobile,
        ".features-accordion": featuresAccordion,
        ".confirm-popup-opener": confirmPopup,
        ".ajax-holder-knowledge-hub": knowledgeHubPagination,
        ".ingredients-slider": ingredientsSlider,
        ".content": content
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js